import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/invoices/page.js");
